import React, { FC, useEffect, useState } from "react";

export const OnScreen = ({ onEnterView, onLeaveView, children, delay = 0, threshold = 0.1, className='' }) => {
	const [ref, setRef] = useState(null);
	const [observer, setObserver] = useState(null);

	useEffect(() => {
		const initObserver = async () => {
			if (typeof window.IntersectionObserver === "undefined") {
				await import("intersection-observer");
			}

			const obs = new IntersectionObserver(
				entries => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							if (delay > 0) {
								setTimeout(() => {
									onEnterView();
								}, delay);
							} else onEnterView();
						} else onLeaveView();
					});
				},
				{ threshold }
			);
			setObserver(obs);
		};

		initObserver();
	}, []);

	useEffect(() => {
		if (ref && observer) observer.observe(ref);
		return () => {
			if (ref && observer) {
				observer.unobserve(ref);
			}
		};
	}, [observer, ref]);

	return (
		<div className={`OnScreen ${className}`} ref={setRef}>
			{children}
		</div>
	);
};

export const LoadOnScreen: FC<{ listen: boolean }> = ({ children, listen }) => {
	const [show, setShow] = useState<boolean>(false);
	return (
		<>
			<OnScreen
				onEnterView={() => {
					setShow(true);
				}}
				onLeaveView={() => null}>
				{listen && show && children}
			</OnScreen>
		</>
	);
};

